export default __webpack_public_path__ + "static/price-icon-efa6de279e0ec8931a92de2b0ce59376.png";